import {
  mayShareIdentifiers,
  onIdentifierConsentChange,
} from '../../consent/identifierConsent'
import { queueCustomPatch, writeCustomDimensions } from './customDimensions'
import { USER_ID_DIMENSION } from './dimensions'

/** The `custom_8` value AY may carry right now. */
export function ayUserIdFor(ayUserId: string | null): string | null {
  return ayUserId && mayShareIdentifiers() ? ayUserId : null
}

/** Write `custom_8` once AY is up, for the consent verdict at that point. */
export function writeAyUserId(ayUserId: string | null): void {
  writeCustomDimensions(() => ({
    [USER_ID_DIMENSION]: ayUserIdFor(ayUserId),
  }))
}

/** Write `custom_8` through on allow and clear it otherwise, at AY's next `beforeRefresh`. */
export function syncAyUserId(ayUserId: string | null): () => void {
  if (!ayUserId) return () => {}
  return onIdentifierConsentChange((state) => {
    queueCustomPatch({
      [USER_ID_DIMENSION]: state === 'allow' ? ayUserId : null,
    })
  })
}
